import { addProvider, getUpgradeType } from '@/services/flexGroup';
import { Button, Form, Input, message, Modal, Space, Select, Switch } from 'antd';
import React, { useState, useEffect } from 'react';
import { ProviderType } from '../provider';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface AddProps {
  visible: boolean;
  refreshTable: () => void;
  onCancel: () => void;
}

interface Extra {
  tags: Array<{ key: string; value: string }>;
  publicIp: boolean | undefined;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 18, offset: 6 },
  },
};

const AddModal: React.FC<AddProps> = (addProps: AddProps) => {
  const { visible, onCancel, refreshTable } = addProps;
  const [form] = Form.useForm<ProviderType | Extra>();
  const [loading, setLoading] = useState(false);
  const [allUpgradeTypes, setAllUpgradeTypes] = useState<any>([]);

  const getUpgradeTypes = async () => {
    const res = await getUpgradeType();
    // console.log('getUpgradeTypes', res)
    if (res.code === 200) {
      setAllUpgradeTypes(
        res.data.details.map((item: any) => {
          return {
            value: item,
            label: item,
          };
        }),
      );
    }
  };

  const onOk = () => {
    form.validateFields().then((res) => {
      setLoading(true);
      if (res.publicIp === undefined) {
        form.setFieldValue('publicIp', false);
      }
      const tags: { [key: string]: string } = {};
      typeof res.tags !== 'string' &&
        res.tags.map((item) => {
          if (item.key) {
            tags[item.key] = item.value || '';
          }
          return item;
        });
      res.tags = JSON.stringify(tags);
      addProvider(res as ProviderType)
        .then((msg) => {
          if (msg?.data.code === 'SUCCESS') {
            message.success('添加成功');
            onCancel();
            refreshTable();
          }
        })
        .finally(() => setLoading(false));
    });
  };

  const upgradeTypesChange = (value: any) => {
    if (value.length === 0) {
      form.setFieldValue('upgradeTypes', []);
    } else {
      form.setFieldValue('upgradeTypes', value);
    }
  };

  const onSwitch = (status: boolean) => {
    form.setFieldValue('publicIp', status);
  };

  useEffect(() => {
    //   getProviderListAll().then((res) => {
    //     setProviders(res?.data.records || []);
    //   });
    getUpgradeTypes();
  }, []);

  return (
    <Modal
      title="新增"
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      width={600}
      maskClosable={false}
      okButtonProps={{ loading: loading }}
    >
      <div className="ProiverEditModalContainer">
        <Form<ProviderType | Extra> labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} form={form}>
          <Form.Item label="名称" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="镜像id" name="imageId" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="供应商" name="type" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="收费类型" name="instanceChargeType" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="实例类型" name="instanceType" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="网络计费类型" name="networkChargeType" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="网络类型" name="networkType" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="区域" name="region" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="安全组" name="securityGroupIds" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="升级标识" name="upgradeTypes">
            <Select
              options={allUpgradeTypes}
              mode="tags"
              tokenSeparators={[',']}
              onChange={upgradeTypesChange}
            />
          </Form.Item>
          <Form.List name="tags" initialValue={[{ key: undefined, value: undefined }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Form.Item
                    {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                    label={index === 0 ? '实例tag信息' : ''}
                    required={false}
                    key={key}
                  >
                    <Space key={key} style={{ display: 'flex' }} align="baseline">
                      <Form.Item {...restField} name={[name, 'key']} noStyle>
                        <Input placeholder="key" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'value']} noStyle>
                        <Input placeholder="value" />
                      </Form.Item>
                      {fields.length > 1 ? (
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      ) : null}
                    </Space>
                  </Form.Item>
                ))}
                <Form.Item {...formItemLayoutWithOutLabel}>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    增加
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Form.Item label="用户数据" name="userData" rules={[{ required: true }]}>
            <Input.TextArea rows={5} />
          </Form.Item>
          <Form.Item label="zone配置信息" name="zoneConfig" rules={[{ required: true }]}>
            <Input.TextArea rows={5} />
          </Form.Item>
          <Form.Item label="是否配置公网ip" name="publicIp" rules={[{ required: false }]}>
            <Switch onChange={onSwitch} />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AddModal;
